(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    'use strict';

    const STORAGE_KEY = 'dwell_wishlist';
    const ACTIVE_CLASS = 'is-active';
    let toastTimeout = null;
    let toastElement = null;

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch {
        return [];
      }
    }

    function saveWishlist(wishlist) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
    }

    function showToast(message, isAdded) {
      if (toastElement && toastElement.parentNode) {
        toastElement.remove();
      }
      if (toastTimeout) {
        clearTimeout(toastTimeout);
      }

      toastElement = document.createElement('div');
      toastElement.className = 'wishlist-toast';
      toastElement.innerHTML = `
        <svg class="wishlist-toast__icon" viewBox="0 0 24 24" fill="currentColor">
          ${isAdded 
            ? '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>'
            : '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="none" stroke="currentColor" stroke-width="2"/>'
          }
        </svg>
        <span>${message}</span>
      `;
      document.body.appendChild(toastElement);

      toastElement.offsetHeight;

      requestAnimationFrame(() => {
        if (toastElement) toastElement.classList.add('show');
      });

      toastTimeout = setTimeout(() => {
        if (toastElement) toastElement.classList.remove('show');
        toastTimeout = setTimeout(() => {
          if (toastElement && toastElement.parentNode) {
            toastElement.remove();
          }
          toastElement = null;
        }, 350);
      }, 2000);
    }

    function initFavoriteButton(button) {
      const productId = button.dataset.productId;
      const wishlist = getWishlist();

      if (wishlist.includes(productId)) {
        button.classList.add(ACTIVE_CLASS);
      }

      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const wishlist = getWishlist();
        const index = wishlist.indexOf(productId);
        const isAdded = index === -1;

        if (isAdded) {
          wishlist.push(productId);
          newButton.classList.add(ACTIVE_CLASS);
          showToast('Added to your wishlist', true);
        } else {
          wishlist.splice(index, 1);
          newButton.classList.remove(ACTIVE_CLASS);
          showToast('Removed from wishlist', false);
        }

        saveWishlist(wishlist);

        document.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { productId: productId, wishlist: wishlist, action: isAdded ? 'added' : 'removed' }
        }));
      });
    }

    function initAllFavorites() {
      document.querySelectorAll('.favorite-button[data-product-id]').forEach(initFavoriteButton);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFavorites);
    } else {
      initAllFavorites();
    }

    document.addEventListener('shopify:section:load', initAllFavorites);

    const observer = new MutationObserver((mutations) => {
      const hasNewCards = mutations.some(m => 
        Array.from(m.addedNodes).some(n => 
          n.nodeType === 1 && (
            n.matches?.('.favorite-button') || 
            n.querySelector?.('.favorite-button') ||
            n.matches?.('product-card') ||
            n.querySelector?.('product-card')
          )
        )
      );
      if (hasNewCards) initAllFavorites();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
